<template>
  <div class="outer bg">
    <div class="inner behind">
      <img :src="require(`@/assets/romme/romme_logo_glow.png`)" class="logo-bg" />
      <img :src="require(`@/assets/romme/romme_swoosh.png`)" class="swoosh" />
      <img :src="require('@/assets/romme/romme_cards_behind.png')" class="cards" alt="Shiny Romme cards" />
    </div>
    <div class="shadow"></div>
    <div class="inner front">
      <img :src="require(`@/assets/romme/romme_logo${logoLocale}.png`)" class="logo" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
const props = defineProps<{ language: string }>()
const logosAvailableForLocales = ['de', 'nl', 'fr']

const logoLocale = computed(() => {
  return logosAvailableForLocales.indexOf(props.language) !== -1 ? `_${props.language}` : ''
})
</script>

<style lang="less" scoped>
@import '~@npm/@gd/common-styles/lib/color-vars';
@import '../../styles/vars';
.outer {
  overflow: hidden;
}
.bg {
  background: #6a2328 url('../../assets/romme/romme_bg_pattern.jpg');
  position: relative;
  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 2em;
    left: 0;
    bottom: 0;
    box-shadow: 0 -2em 0.5em -1.8em rgba(0, 0, 0, 0.35) inset;
  }
}
.behind {
  @media screen and (max-width: 660px) {
    overflow: hidden;
  }
}
.swoosh {
  position: absolute;
  right: 8em;
}
.logo-bg {
  position: absolute;
  width: 30.25em;
  height: 10em;
  left: -9em;
  z-index: 0;
  @media screen and (max-width: @framemaxwidth) {
    left: -7.75em;
  }
}
.cards {
  position: absolute;
  width: 27.25em;
  height: 8.6875em;
  right: 0;
  bottom: 0;
  @media screen and (max-width: 660px) {
    right: -8em;
  }
}
.shadow {
  width: 100%;
  height: 100%;
  // background: linear-gradient(to top, rgba(255, 197, 183, 0.16) 0, rgba(254, 253, 183, 0) 100%);
}
.logo {
  position: absolute;
  width: 13.3125em;
  height: 6.3125em;
  top: 1.5em;
  @media screen and (max-width: @framemaxwidth) {
    left: 1.25em;
  }
}
</style>
